const TRACKER_ID = "pb24-metricool-script";
const TRACKER_SRC = "https://tracker.metricool.com/resources/be.js";
const TRACKING_HASH = process.env.REACT_APP_METRICOOL_TRACKING_HASH;

let enabled = false;
let loaded = false;
let lastTrackedUrl = "";

function isPreviewOrTestContext() {
  const host = (window.location.hostname || "").toLowerCase();
  const ua = (navigator.userAgent || "").toLowerCase();
  return host === "localhost"
    || host === "127.0.0.1"
    || host.endsWith(".preview.emergentagent.com")
    || host.endsWith(".emergentagent.com")
    || /(playwright|headlesschrome|puppeteer|selenium)/.test(ua);
}

function sendPageView() {
  if (!enabled || !loaded || !TRACKING_HASH || !window.beTracker) return;
  const url = window.location.href;
  if (url === lastTrackedUrl) return;
  lastTrackedUrl = url;
  window.beTracker.t({ hash: TRACKING_HASH });
}

export function syncMetricoolConsent(hasAnalyticsConsent) {
  enabled = Boolean(hasAnalyticsConsent) && !isPreviewOrTestContext();
  if (!enabled || loaded || !TRACKING_HASH) return;

  const existing = document.getElementById(TRACKER_ID);
  if (existing) return;

  const script = document.createElement("script");
  script.id = TRACKER_ID;
  script.async = true;
  script.src = TRACKER_SRC;
  script.onload = () => {
    loaded = true;
    sendPageView();
  };
  document.head.appendChild(script);
}

export function trackMetricoolRoute() {
  sendPageView();
}